import React from 'react';
import {WidgetProps, useEnvironment} from '@wix/yoshi-flow-editor';
import {IControllerProps} from '../../../types/app.types';
import {CartWidgetRoot} from '../../../common/components/CartWidgetRoot';
import {SideCart} from './SideCart';
import {withExpressCheckoutButtons} from '@wix/ecom-platform-express-checkout-buttons/widget';
import {withSlotsPlaceholders} from '@wix/widget-plugins-ooi';

const SideCartAppRoot = (controllerProps: WidgetProps<IControllerProps>) => {
  const {isRTL} = useEnvironment();

  return (
    <CartWidgetRoot controllerProps={controllerProps}>
      <SideCart dir={isRTL ? 'rtl' : 'ltr'} />
    </CartWidgetRoot>
  );
};

export default withSlotsPlaceholders(withExpressCheckoutButtons(SideCartAppRoot));
